module.exports = __webpack_public_path__ + "static/media/loading.24282fe2.gif";